import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LanguageService } from 'src/app/shared/services/language.service';

@Component({
  selector: 'app-he11',
  templateUrl: './he11.component.html',
  styleUrls: ['./he11.component.scss']
})
export class He11Component implements OnInit {
  show = false;
  link: any;

  constructor(
    private languageService: LanguageService,
    private sanitizer: DomSanitizer
  ) {

  }
  ngOnInit(): void {
    window.scroll({ top: 0 });
    this.languageService.selectedLanguage.subscribe(lang => {
      lang ?
        this.link = this.sanitizer.bypassSecurityTrustResourceUrl(`https://docs.oncubatravel.com/${lang}/doc/add/HE11/`) :
        this.link = this.sanitizer.bypassSecurityTrustResourceUrl(`https://docs.oncubatravel.com/es/doc/add/HE11/`);
      this.show = true;
    });
  }

}
